<!-- qesg-dash-card-icon -->
<template>
    <div :class="['d-flex dash-card-icon rounded', `bg-opacity-${variant}`, `border border-opacity-${variant} border-width-2`]">
        <b-icon
            :icon="icon"
            :variant="variant"
            :font-scale="fontScale"
            v-bind="[{iconFontScale: !iconFontScale ? false : iconFontScale}]"
            />
    </div>
</template>

<script>
import { BIcon } from 'bootstrap-vue';

export default {
    name: 'qesg-dash-card-icon',
    components: {
        BIcon
    },
    props: {
        icon: {
            type: String,
            required: false,
            default: (iconProps) => typeof iconProps === 'undefined' ? '' : iconProps
        },
        variant: {
            type: String,
            required: false,
            default: (variantProps) => typeof variantProps === 'undefined' ? 'dark' : variantProps
        },
        fontScale: {
            type: Number,
            required: false,
            default: 0
        },
        iconFontScale: {
            type: Number,
            required: false,
            default: 0
        },
    },
    computed: {}
}
</script>

<style>

</style>